import { api } from "../config/config";
import { ILanguage } from "../services/api.services";
import { IAttribute, IGallery } from "../states/state";

// Image handling functions
export const getImageUrl = (filename?: string) => {
  if (!filename) return undefined;
  return `${api.img}/${filename}`;
};

export const getGalleryByTag = (gallery: IGallery[] | undefined, tag: string) => {
  if (!gallery?.length) return [];
  return gallery
    .filter(item => item.document.tags.includes(tag))
    .map(item => getImageUrl(item.document.file.filename));
};

// Simplified gallery getters
export const getMainImage = (gallery?: IGallery[]) => {
  if (!gallery?.length) return;
  const mainImage = gallery.find(item => item.main) || gallery[0];
  return getImageUrl(mainImage?.document.file.filename);
};

export const getUnitImages = (gallery?: IGallery[]) => 
  getGalleryByTag(gallery, 'unit');

export const getPropertySliderGallery = (gallery?: IGallery[]) => 
  getGalleryByTag(gallery, 'slider');

export const getPropertyUnitGallery = (gallery?: IGallery[]) => 
  getGalleryByTag(gallery, 'unit');

export const getPropertyMapGallery = (gallery?: IGallery[]) => 
  getGalleryByTag(gallery, 'plan');

// Attribute handling functions
export const getAttributeValue = (attributes: IAttribute[] | undefined, key: string) => {
  const attribute = attributes?.find(attr => 
    new RegExp(key, 'i').test(attr.attribute?.key)
  );
  return attribute?.value;
};

export const getAttributeChoice = (attribute?: IAttribute) => {
  if (!attribute?.value || !attribute?.attribute.choices) return;
  return attribute.attribute.choices.find(choice => 
    choice.value === attribute.value
  );
};

// Simplified attribute getters
export const getLocation = (attributes?: IAttribute[]) => 
  getAttributeChoice(attributes?.find(attr => 
    new RegExp('LOCATION', 'i').test(attr.attribute?.key)
  ));

export const getFloorplans = (attributes?: IAttribute[]) => 
  getAttributeValue(attributes, 'FLOOR-PLANS');

export const getAddress = (attributes?: IAttribute[]) => 
  getAttributeChoice(attributes?.find(attr => 
    new RegExp('ADDRESS', 'i').test(attr.attribute?.key)
  ));

export const getState = (attributes?: IAttribute[]) => 
  getAttributeChoice(attributes?.find(attr => {
    return new RegExp('STATE', 'i').test(attr.attribute?.key)
  }));

export const getLink = (attributes?: IAttribute[]) => 
  getAttributeValue(attributes, 'LINK');

export const getPDFLink = (attributes?: IAttribute[]) => 
  getAttributeValue(attributes, 'LINK_PDF');

// Language helper
export const getValueByLang = (value?: string | ILanguage, lang?: string) => {
  if (!value || !lang) return '';
  if (typeof value === 'string') return value;
  console.log(lang);
  return value[lang.toLowerCase()] || 
         value[Object.keys(value)[0]] || 
         value[Object.keys(value)[1]];
};